import { gql, type TypedDocumentNode } from '@apollo/client';
import { SearchUserQueryEnum, GenderEnum_TS } from '@rivallapp/volosports-components';

export type UserInfoInput = {
  input: {
    search: string;
    which: SearchUserQueryEnum;
  };
};

export type UserInfoResult = {
  getUserByInfo: {
    _id: string;
    firstName: string;
    lastName: string;
    gender: GenderEnum_TS;
    email: string;
  };
};

export default gql`
  query getUserByInfo($input: UserInfoInput!) {
    getUserByInfo(input: $input) {
      _id
      firstName
      lastName
      gender
      email
    }
  }
` as TypedDocumentNode<UserInfoResult, UserInfoInput>;
